import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Box, Flex, Typography } from '@web-apps/ui-shared'

import { clearRNWebViewCredential } from '../../utils/helpers/rnWebView.helpers'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  height: 100vh;
  text-align: center;
`

export const NeedsNativeAuth = () => {
  const { t } = useTranslation(['auth'])

  useEffect(() => {
    clearRNWebViewCredential()
  }, [])

  return (
    <StyledContainer>
      <Box my={64} px={24}>
        <Flex gap={16} direction="column" align="center">
          <Typography variant="h2" fontWeight="600">
            {t('auth:errors.session_refresh_required')}
          </Typography>
        </Flex>
      </Box>
    </StyledContainer>
  )
}
